import fs from 'fs-extra'
import Zip from 'zip-folder'
const dbTypes = ['BOOLEAN', 'STRING', 'NUMBER', 'DATE']
const graphqlTypes = ['INT','FLOAT','BOOLEAN','STRING']
function generateMutations(tables) {
    let createMutations = tables.map((table) => {
        let temp = `\n\tregister(username:String!,email:String!,password:String!):User
        emailLogin(email:String!,password:String!):LoginPayload
        usernameLogin(username:String!,password:String!):LoginPayload\n\tcreate${table.name}(`
        let schema = table.fields.filter(field => field.name != 'id').map((field) => {
            if(!(graphqlTypes.includes(field.type.toUpperCase())))return `${field.name}:String`
            return `${field.name}:${field.type}`
        })
        return (temp + schema + `):${table.name}`)
    })
    let updateMutations = tables.map((table) => {
        let temp = `\n\tupdate${table.name}(id:String,`
        let schema = table.fields.filter(field => field.name != 'id').map((field) => {
            if(!(graphqlTypes.includes(field.type.toUpperCase())))return `${field.name}:String`
            return `${field.name}:${field.type}`
        })
        return (temp + schema + `):${table.name}`)
    })
    let deleteMutations = tables.map((table) => {
        let temp = `\n\tdelete${table.name}(id:String!):${table.name}`
        return (temp)
    })

    return 'type Mutation{' + createMutations + updateMutations + deleteMutations + `\n}`
}
function getPopulates(table) {
    let populates = table.fields.filter((field) => (!(dbTypes.includes(field.type.toUpperCase()))))
    populates = populates.map((populate) => {
        return `.populate('${populate.name}')`
    })
    populates = populates.toString().replace(/,/g, "");
    return populates
}
function prepareMapedPermissions(table,state){
    if(table.options.mapToUser){
        if(!table.options.mapedPermissions||table.options.mapedPermissions.includes(state)){
            return(`if(!(context.user._id==${table.name}.owner))throw new Error("you are not authorized")`)
    }else{
        return(``)
    }
}else{
        return(``)
    }
}
function prepareAuthenticationPermissions(table,state){
    if(table.options.authenticated ){
        if(!table.options.authenticationPermissions || table.options.authenticationPermissions.includes(state)){
            return(`if(!context.user)throw new Error("you are not authenticated")`)
        }
    }else{
        return(``)
    }
}
function generateQueriesResolvers(tables) {
    let allQueries = tables.map((table) => {
        let populates = getPopulates(table)
        let permissions = ``
        
        return (`\n\tall${table.name}:(_,data,context,info)=>{
        
        ${prepareAuthenticationPermissions(table,"a")}
        return ${table.name}.find()${populates}.exec()}`)
    })
    let findQueries = tables.map((table) => {
        let populates = getPopulates(table)
        return (`\n\t${table.name}:(_,data,context,info)=>{
            ${prepareAuthenticationPermissions(table,"f")}
            ${prepareMapedPermissions(table,"f")}
           
        return ${table.name}.findOne({_id:data.id})${populates}.exec()}`)
    })
    return `Query:{` + allQueries + ',' + findQueries + '\n}'
}
function generateMutationsResolvers(tables) {
    const  createMutations = tables.map((table) => {
        let populates = getPopulates(table);
        if(!populates){return(`\n\tcreate${table.name}:async(_,data,context,info)=>{
            ${prepareAuthenticationPermissions(table,"c")}
            ${prepareMapedPermissions(table,"c")}     
            return ${table.name}.create(data)}`)}
        
        return (`\n\tcreate${table.name}:async(_,data,context,info)=>{
            ${prepareAuthenticationPermissions(table,"c")}
            ${prepareMapedPermissions(table,"c")}
            let ${table.name.toLowerCase()} = await ${table.name}.create(data)
            return ${table.name}.findOne({_id:${table.name.toLowerCase()}._id})${populates}.exec()}`)
    })
    const updateMutations = tables.map((table) => {
        let populates = getPopulates(table);
        return (`\n\tupdate${table.name}:(_,data,context,info)=>{
            ${prepareAuthenticationPermissions(table,"u")}
            ${prepareMapedPermissions(table,"u")}
            let ${table.name.toLowerCase()} =  ${table.name}.findOne({_id:data.id}).exec();
            if(!${table.name.toLowerCase()})throw new Error("cant find ${table.name.toLowerCase()} with provided id")
            ${table.name.toLowerCase()}.set(data)
            let saved${table.name.toLowerCase()} = ${table.name.toLowerCase()}.save()
            return ${table.name}.findOne({_id:saved${table.name.toLowerCase()}._id})${populates}.exec()}`)
    })
    const deleteMutations = tables.map((table) => {
        let populates = getPopulates(table);
        return (`\n\tdelete${table.name}:(_,data,context,info)=>{
            ${prepareAuthenticationPermissions(table,"d")}
            ${prepareMapedPermissions(table,"d")}
            let ${table.name.toLowerCase()} =  ${table.name}.findOne({_id:data.id}).exec();
            if(!${table.name.toLowerCase()})throw new Error("cant find ${table.name.toLowerCase()} with provided id")
            const deleted = ${table.name}.findOne({_id:data.id})${populates}.exec();   
            ${table.name}.findOne({_id:data.id}).remove().exec() 
            return deleted}`)
            })

    return `Mutation:{\n\t register:async (_,data,context,info)=>{
        return User.register(data)
    },
      emailLogin:async (_,data,context,info)=>{
        return User.emailLogin(data);
      },
      usernameLogin:async (_,data,context,info)=>{
        return User.usernameLogin(data);
      },` + createMutations +','+ updateMutations +',' + deleteMutations + `\n}`
}
function generateQueries(tables) {
    let allQueries = tables.map((table) => {
        return `\n\tall${table.name}:[${table.name}]`
    });
    let findQueries = tables.map((table) => {
        let temp = `\n\t${table.name}(id:String!):${table.name}`
        return (temp)
    })
    return 'type Query{' + allQueries + findQueries + `\n}`
}
function generateResolvers(tables,options) {
    let literal = `import User from '../models/user'\n`
    tables.forEach((table) => literal = literal + `import ${table.name} from "../models/${table.name}Model"\n`)
    literal = literal + `const resolvers = {\n\t`
    let queries = generateQueriesResolvers(tables)
    let mutations = generateMutationsResolvers(tables)
    literal = literal + queries + ',' + mutations + '\n}\nexport default resolvers'
    fs.writeFile(`./${options.title}/src/graphql/resolvers.js`, literal, (err) => {
        if (err) console.log(err);
        generateConfig(options)
    })

}
export function generateGraphqlSchema(tables,options) {
    let literal = `import {makeExecutableSchema} from 'graphql-tools'\nimport resolvers from './resolvers'\nconst typeDefs = \`
    type User{
        id:String!
        email:String
        username:String
        
        },
    type LoginPayload{
          id:String
          token:String
          username:String
          email:String
        },`
    let schemas = tables.map((table) => {
        let temp = `\n\ttype ${table.name} {\n\t id:String`
        let schema = table.fields.map((field) => {
            /*  if(field.type.toUpperCase() == "DATE" ){return `\n\t${field.name}:String`}
             if(field.type.toUpperCase() == "INT" ){return `\n\t${field.name}:Int`}
             if(field.type.toUpperCase() == "INT" ){return `\n\t${field.name}:Int`}
             if(field.type.toUpperCase() == "BOOLEAN" ){return `\n\t${field.name}:Boolean`} */
            return `\n\t${field.name}:${field.type}`
        })


        schema = schema.toString();
        schema = schema.replace(/,/g, "");
        let timeStamps = `\n\t\tcreatedAt:String,\n\tupdatedAt:String`
        return (temp + schema + timeStamps + `\n}`)

    })



    literal = literal + schemas + ','
    let queries = generateQueries(tables)
    literal = literal + queries + ','
    let mutations = generateMutations(tables)
    literal = literal + mutations
    literal = literal + `
    \`\nconst Schema = makeExecutableSchema({typeDefs,resolvers});\nexport default Schema
    `
    fs.writeFile(`./${options.title}/src/graphql/index.js`, literal, (err) => {
        if (err) console.log(err);
        generateResolvers(tables,options)
    })


}
function generateUserModel(options){
    const userModelLiteral = `import mongoose from 'mongoose'
    import config from '../../config';
    import bcrypt from 'bcrypt-nodejs';
    import jwt from 'jsonwebtoken';
    import Mailgun from 'mailgun-js';
    const userSchema = mongoose.Schema({
        email:{
            type:String,
            required:true,
            unique:true ,
            trim:true,
            match:/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        },
        password:{
            type:String,
            required:true,
        },
        username:{
            type:String,
            required:true,
            unique:true
        },
        active:{
            type:Boolean,
            default:false
        }
    });
    userSchema.set('validateBeforeSave', false);
    userSchema.path('password').validate((password)=>{
        return (password.length > 7)
    });
    userSchema.pre('save', function(next) {
    this.password = bcrypt.hashSync(this.password);
    next();
    });
    const mailgun = Mailgun({apiKey:config.mailgun_key,
        domain: config.mailgun_domain});
    userSchema.statics = {
        register:async function register(data){

           const  user = new User(data);
           await user.validate()
           const savedData =  await user.save();
           const token = jwt.sign({_id:user._id,type:'activation link'},
            config.secret,{ expiresIn: 60*60*24*7 } );
           const msg = {
            from: config.system_auth_mail,
            to: user.email,
            subject: 'activate your account',
            text: 'please activate you account '
        };
        mailgun.messages().send(msg, function (err, body) {
            if(err) console.log(err);
        });
        return savedData
         },
           emailLogin:async(data)=>{
             var user = await User.findOne({email:data.email}).exec();
             if(user.validatePassword(data.password)){
               var Token = jwt.sign({_id:user._id},
                             config.secret,{ expiresIn: 60*60*24*7 })
                return{token:Token,username:user.username,email:user.email,id:user._id}
             }else{
              throw new Error("user not found")
             }
    
           },
    
        usernameLogin:async(data)=>{
          var user = await User.findOne({username:data.username}).exec();
          if(user.validatePassword(data.password)){
            var Token = jwt.sign({_id:user._id},
                          config.secret,{ expiresIn: 60*60*24*7 })
             return{token:Token,username:user.username,email:user.email,id:user._id}
          }else{
             throw new Error("user not found")
          }
    
    
    
        }
    };
    userSchema.methods={
        validatePassword: function(password) {
          var d = bcrypt.compareSync(password, this.password);
    
            return d
    
        },
        sendActivationEmail:function () {
            var token = jwt.sign({_id:this._id,type:'activation link'},
                config.secret,{ expiresIn: 60*60*24*7 } );
    
            var data = {
                from: config.system_auth_mail,
                to: this.email,
                subject: 'activate your account',
                text: "please activate you account "
            };
            mailgun.messages().send(data, function (err, body) {
                if(err)throw err
            });
        }
    };
    const User = mongoose.model("User",userSchema);
    export default User
    
    `
    fs.writeFile(`./${options.title}/src/models/user.js`, userModelLiteral, (err) => {
        if (err) console.log(err);

    })
    
}
export function generateMongooseSchema(tables,options) {
    generateUserModel(options)
    tables.forEach(function (table) {
        let literal = `import mongoose from 'mongoose'\nconst ${table.name}Schema = mongoose.Schema({`
        
        let schema = table.fields.map((field) => {
            let type = ''
            if (field.type.toUpperCase() == "INT" || field.type.toUpperCase() == "FLOAT") {
                type = "Number"
            }
            if (field.type.toUpperCase() == "BOOLEAN") {
                type = "Boolean"
            }
            if (field.type.toUpperCase() == "STRING" ) {
                type = "String"
            }
            if(field.type.toUpperCase() == "DATE"){
                type = "Date"
            }
            let options = ``
            if (field.options) {
                if (field.options.required)  options = options + 'required:true,'
                if (field.options.unique)    options = options + '\n\tunique:true,'
                if (field.options.lowerCase) options = options + '\n\tlowerCase:true,'
                if (field.options.upperCase) options = options + '\n\tupperCase:true,'
                if (field.options.trim)      options = options + '\n\ttrim:true,'
                if (field.options.enum){
                    const temp = field.options.enum.map(el=>`"${el}"`)
                    options = options + `\n\tenum:[${temp}],`
                }
                if (field.options.default){
                    if(field.type == "Date"){
                        if(field.options.default == "now"){
                            options = options + `\n\tdefault:new Date(),`
                        }else{
                            options = options + `\n\tdefault:"${field.options.default}",`
                        }
                    }
                    
                    if(field.type=="String"){
                        options = options + `\n\tdefault:"${field.options.default}",`
                    
                    }if(field.type.toUpperCase() == "INT" || field.type.toUpperCase() == "FLOAT"
                    ||field.type.toUpperCase() == "BOOLEAN"){
                        options = options + `\n\tdefault:${field.options.default},` 
                    }
                    
                    
                }    
            }
            if (type == '') {
                if(!field.options.many && !field.options.manyToMany){
                    return `\n\t${field.name}:{\n\ttype:mongoose.Schema.Types.ObjectId,\n\tref:'${field.type}'
                }`
                }if(field.options.many){
                    return `\n\t${field.name}:{\n\ttype:[mongoose.Schema.Types.ObjectId], ref: '${field.type}'`
                }if(field.options.manyToMany){
                    const manyToManyLiteral = `import mongoose from 'mongoose'
                    const ${table.name}To${field.name}Schema = mongoose.Schema({
                        ${table.name}:mongoose.Schema.Types.ObjectId,
                        ${field.name}:mongoose.Schema.Types.ObjectId,
                        timestamps: { createdAt: 'createdAt',updatedAt:'updatedAt' } })
                        export default mongoose.model("${table.name}To${field.name}",${table.name}To${field.name}Schema)
                    `
                }
                
            }
            return `\n\t${field.name}:{\n\ttype:${type},\n\t${options}
         }`

        })
        let owner = ``
        if(table.options.mapToUser){
            owner = `,\n\towner:{\n\ttype:mongoose.Schema.Types.ObjectId,\n\tref:'User'\n},`
        }
        literal = literal + schema + owner + `\n timestamps: { createdAt: 'createdAt',updatedAt:'updatedAt' } })\nexport default mongoose.model("${table.name}",${table.name}Schema)`
        fs.writeFile(`./${options.title}/src/models/${table.name}Model.js`, literal, (err) => {
            if (err) console.log(err);

        })

    });
    generateGraphqlSchema(tables,options)

}
export function generateConfig(options){
    require('crypto').randomBytes(48, function(err, buffer) {
        var token = buffer.toString('hex');
        const literal = `module.exports ={
            "port":3000,
	        "bodyLimit": "100kb",
	        "corsHeaders": ["Link"],
            "secret":"${token}",
            "mailgun_key":"key-a3629c2b0b22d3e51c5e0fa65034e709",
            "mailgun_domain":"mailgun.genemedlab.net",
            "system_auth_mail":"${options.title} <auth@${options.title}.com>",
            "db":"${options.db}"
        }`
        fs.writeFile(`./${options.title}/config.js`, literal, (err) => {
            if (err) console.log(err);
            Zip(`./${options.title}`, `./${options.title}.zip`, function(err) {
                if(err) {
                    console.log('config file is not created !! !', err);
                } else {
                    fs.remove('./${options.title}', err => {
                        if (err) return console.error(err)
                        console.log("deleted !")
                    })

                    console.log('EXCELLENT');
                }
            });

        })
      });
}
function prepareTemplate(tables,options) {
    fs.copy('./template', options.title, function (err) {
        if (err) return console.error(err)
        generateMongooseSchema(tables,options)
    });
}
export async function generateFiles(tables,options) {
    prepareTemplate(tables,options)



}